import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider, PAGE_SIZES, SMALL_PAGE_SIZES) {
	const states = [
		{
			name: 'unifilarParameters',
			parent: 'measurements',
			url: '/unifilarParameters?page&sort&size&road&campaign&plantype',
			component: 'unifilarParametersSearch',
			data: {
				viewAuthorities: ['ANALYSIS_READ', 'UNIFILARPARAMETERS_READ'],
				editAuthorities: ['ANALYSIS_WRITE', 'ANALYSIS_PARTIAL_WRITE', 'UNIFILARPARAMETERS_WRITE']
			},
			params: {
				page: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				},
				sort: {
					value: 'name,asc',
					squash: true,
					dynamic: true
				},
				road: {
					type: 'int',
					squash: true,
					dynamic: true
				},
				campaign: {
					type: 'int',
					squash: true,
					dynamic: true
				},
				plantype: {
					type: 'int',
					squash: true,
					dynamic: true
				}
			},
			resolve: {
				/* @ngInject */
				allOrganizations: [
					'Organization',
					Organization => {
						return Organization.query({ sort: 'name,asc' }).$promise;
					}
				],
				/* @ngInject */
				allRoads: Road => Road.query({ sort: 'name,asc', empty: false }).$promise,
				/* @ngInject */
				allCampaigns: Campaign =>
					Campaign.query({ sort: 'name,asc', empty: false }).$promise,
				/* @ngInject */
				allCriteriaSets: CriteriaSet => CriteriaSet.query({ sort: 'name,asc' }).$promise
			}
		},
		{
			name: 'unifilarParameters.detail',
			url: '/{id}',
			component: 'unifilarParametersDetail',
			resolve: {
				/* @ngInject */
				entity: (UnifilarParameters, $transition$, entityInjector) =>
					entityInjector(UnifilarParameters, $transition$.params().id, {})
			}
		},
		{
			name: 'unifilarParameters.result',
			url:
				'/{id}/result?milestonePage&milestoneSize&yearPage&yearSize&direction&lanes&metric',
			component: 'unifilarParametersResult',
			params: {
				milestonePage: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				},
				milestoneSize: {
					value: PAGE_SIZES[3],
					type: 'int',
					squash: true,
					dynamic: true
				},
				yearSize: {
					value: SMALL_PAGE_SIZES[1],
					type: 'int',
					squash: true,
					dynamic: true
				},
				yearPage: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				},
				direction: {
					value: null,
					squash: true,
					dynamic: true
				},
				lanes: {
					array: true,
					value: [],
					type: 'int',
					squash: true,
					dynamic: true
				},
				metric: {
					value: null,
					squash: true,
					dynamic: true
				},
				//[Sprint Jan-2025] [US 126] [46h] Visualização de TODO o unifilar de parâmetros na tela do sistema  (start)
				allUnifilarParameter: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				}
				//[US 126] (end)
			},
			resolve: {
				/* @ngInject */
				entity: (UnifilarParameters, $transition$, entityInjector) =>
					entityInjector(UnifilarParameters, $transition$.params().id, {})
			}
		},
		{
			name: 'unifilarParameters.result.editComments',
			url: '/{id}',
			component: 'unifilarParametersEditComments'
		},
		{
			name: 'unifilarParameters.result.editComments.segment',
			url: '/segments/{iid}',
			component: 'unifilarParametersEditCommentsSegmentDetail'
		}
	];

	states.forEach(state => $stateProvider.state(state));
}

app.config(stateConfig);
